import React from 'react';
import { partners } from '../mockData';

const Partners = () => {
  return (
    <section id="partners-section" className="partners-section" aria-label="Our Partners">
      <div className="container">
        <div className="section-header">
          <span className="section-badge">Trusted Partnerships</span>
          <h2 className="section-title">Our Partners</h2>
          <p className="section-description">
            Collaborating with leading organizations across the UAE to deliver 
            exceptional landscape and gardening solutions
          </p>
        </div>

        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div 
              key={partner.id} 
              className="partner-card"
              data-testid={`partner-card-${partner.id}`}
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="partner-logo-wrap">
                <img
                  src={partner.logo}
                  alt={`${partner.name} logo`}
                  className="partner-logo-img"
                  loading="lazy"
                  onError={(e) => { e.target.style.display = 'none'; e.target.nextSibling.style.display = 'flex'; }}
                />
                <span className="partner-logo-fallback" style={{ display: 'none' }}>
                  {partner.name.charAt(0)}
                </span>
              </div>
              <div className="partner-content">
                <h3 className="partner-name">{partner.name}</h3>
                <span className="partner-category">{partner.category}</span>
              </div>
              <div className="partner-hover-effect"></div>
            </div>
          ))}
        </div>

        <div className="partners-note">
          <p>Proud to work alongside industry leaders, government entities, and innovative developers</p>
        </div>
      </div>
    </section>
  );
};

export default Partners;
